import { type ValueOf } from '~/common/types';

export const FINANCE_TABS = {
  ACCOUNTS: 'accounts',
  ARCHIVE: 'archive',
  BOOK_YEAR: 'book-year',
  BOOKINGS: 'bookings',
  CLIENTS: 'clients',
  INVOICES: 'invoices',
  REJECTED: 'rejected',
  SUPPLIERS: 'suppliers',
  TO_VALIDATE: 'to-validate',
} as const;

export type FinanceTab = ValueOf<typeof FINANCE_TABS>;

export const NO_BOOK_YEAR_TABS = [
  FINANCE_TABS.ACCOUNTS,
  FINANCE_TABS.CLIENTS,
  FINANCE_TABS.SUPPLIERS,
] as const;

export const FINANCE_TAB_KEYS = [
  FINANCE_TABS.TO_VALIDATE,
  FINANCE_TABS.INVOICES,
  FINANCE_TABS.BOOKINGS,
  FINANCE_TABS.ACCOUNTS,
  FINANCE_TABS.CLIENTS,
  FINANCE_TABS.SUPPLIERS,
  FINANCE_TABS.ARCHIVE,
  FINANCE_TABS.REJECTED,
] as const;

export const FINANCE_TABS_STORAGE_KEY = 'homeownerAssociationFinancePinnedActions';
